import { render, staticRenderFns } from "./BlogsList.vue?vue&type=template&id=55409e2b&scoped=true"
import script from "./BlogsList.vue?vue&type=script&lang=js"
export * from "./BlogsList.vue?vue&type=script&lang=js"
import style0 from "./BlogsList.vue?vue&type=style&index=0&id=55409e2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55409e2b",
  null
  
)

export default component.exports